jQuery(window).load(function () {
    var wrap = jQuery('#popup_overlay');
    var behavior = wrap.attr('data-behavior');
    if (behavior === 'window_load') {
        var visited = jQuery.cookie('visited');
        if (visited == 'yes') {
            // second page load, cookie active
        } else {
            popUp();
        }
        jQuery.cookie('visited', 'yes', {
            expires: Number(expire_days_cookie_popup)
        });
    }

});

function onMouseOut(event) {
    // If the mouse is near the top of the window, show the popup
    // Also, do NOT trigger when hovering or clicking on selects
    var wrap = jQuery('#popup_overlay');
    var behavior = wrap.attr('data-behavior');
    if (behavior === 'window_close' &&
        event.clientY < 2 &&
        event.relatedTarget == null &&
        event.target.nodeName.toLowerCase() !== 'select') {
        // Remove this event listener
        document.removeEventListener("mouseout", onMouseOut);

        // Show the popup
        var visited = jQuery.cookie('visited');
        if (visited == 'yes') {
            // second page load, cookie active
        } else {
            popUp();
        }
        jQuery.cookie('visited', 'yes', {
            expires: Number(expire_days_cookie_popup)
        });
    }
}

document.addEventListener("mouseout", onMouseOut);

function popUp() {
    var wrap = jQuery('#popup_overlay');
    jQuery('body').append(wrap);
    if (wrap.length > 0) {
        jQuery('html').addClass('no_scroll');
        wrap.fadeIn();
        centerPopUp();
        wrap.find('.close_popup').click(function () {
            wrap.fadeOut('fast');
            jQuery('html').removeClass('no_scroll');
        });

        var countDownId = jQuery('#countdown');

        if (countDownId.length > 0) {

            // Set the date we're counting down to

//			var countDownDate = new Date("Jan 5, 2021 15:37:25").getTime();
            var countDownDate = timestamp * 1000;
            // Update the count down every 1 second
            var x = setInterval(function () {

                // Get today's date and time
                var now = new Date().getTime();

                // Find the distance between now and the count down date
                var distance = countDownDate - now;

                // Time calculations for days, hours, minutes and seconds
                var days = Math.floor(distance / (1000 * 60 * 60 * 24));
                var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                var seconds = Math.floor((distance % (1000 * 60)) / 1000);

                // Display the result in the element with id=countDownId
                //document.getElementById(countDownId).innerHTML = days + "d " + hours + "h " + minutes + "m " + seconds + "s ";

                countDownId.find('.days .val').html(days);
                countDownId.find('.hours .val').html(hours);
                countDownId.find('.minutes .val').html(minutes);
                countDownId.find('.seconds .val').html(seconds);

                // If the count down is finished, write some text
                if (distance < 0) {
                    clearInterval(x);
                    countDownId.html("EXPIRED");
                    //document.getElementById(countDownId).innerHTML = "EXPIRED";
                }
            }, 1000);
        }
    }
}
function centerPopUp() {
    var wrap = jQuery('#popup');
    if (wrap.length > 0 && !is_phone) {
        var wh = jQuery(window).height(),
            wrapH = wrap.height(),
            top = 20;
        console.log('wrap_height_changed', wrapH);
        if (wh > wrapH) {
            top = (wh - wrapH) / 2
        }
        wrap.css({
            'margin-top': top - 100
        })
    }
}